import { _ as yt } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.number.constructor-fc5c8929.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.promise.resolve-c679daba.js";
import { useTheme as At } from "@ucl/shared-component-foundations";
import { useCustomTranslation as Ct } from "@ucl/ucl-translation";
import { c as b } from "./index-8b07dec9.js";
import Pt, { useState as M, useRef as Ot } from "react";
import z, { css as G } from "styled-components";
import { getAriaProps as x } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Tt } from "./getMetrics-953aa4f8.js";
import { _ as S, T as Lt } from "./index-f5b44da3.js";
import { a as F } from "./index-5d0f31c6.js";
import "./carousel.js";
import "./es.object.keys-9d66766f.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { jsx as p, jsxs as Wt } from "react/jsx-runtime";
import "./es.string.trim-6e13db75.js";
import { InputState as y } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { uniqueId as Rt } from "./uniqueId.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./is-pure-c0f11fe0.js";
import "./es.symbol.description-6025a604.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./function-apply-4756dee6.js";
import "./inherit-if-required-f068457b.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./this-number-value-32e86ff7.js";
import "./string-trim-14e37ad3.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./environment-is-node-a035d787.js";
import "./environment-ddee5959.js";
import "./set-species-5ede2ed0.js";
import "./an-instance-6efcfd6c.js";
import "./species-constructor-00346775.js";
import "./validate-arguments-length-eb516e5b.js";
import "./safe-get-built-in-a8d8c20c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./object-to-array-0474b7e7.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./array-method-is-strict-e5a3c878.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "react-dom";
import "./useWindowSize.js";
import "./isClient-2f5bedbd.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./es.array.join-c1bca812.js";
import "./image.js";
import "./aspectRatio.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./index-f2264f1e.js";
import "./iconButton.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "@ucl/shared-icons";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./getElementPosition-8d0dbc61.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./string-html-forced-a746405b.js";
import "./es.global-this-a7f40ce1.js";
import "./closeButton.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./useMediaQuery.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./tooltip.js";
var wt = "Search Input: Location", Vt = "https://autosuggest.search.hereapi.com/v1/autosuggest?at=", Dt = "95.7129", Nt = "37.0902", $t = ["textSize", "longitude", "latitude", "apiKey", "value", "limit", "disabled", "required", "placeholder", "onChange", "onBlur", "labelProp", "infoProp", "trailingText", "helperTextProp", "inputState", "startAdornmentProp", "countryCode", "languageCode", "accessibilityOptions", "exceedOverflow", "menuDirection", "menuWidth", "noResultText"], jt = "SearchInputLocation", Et = /* @__PURE__ */ z.div.withConfig({
  displayName: "searchInputLocation__InputAndSuggestionWrapper",
  componentId: "sc-2wff48-0"
})(["&.InputAndSuggestionWrapper{", ";}"], function(t) {
  var l = t.theme.components.searchInputLocation;
  return G(l.InputAndSuggestionWrapper);
}), k = /* @__PURE__ */ z.div.withConfig({
  displayName: "searchInputLocation__IconWrapper",
  componentId: "sc-2wff48-1"
})(["&.IconWrapper{", ";}"], function(t) {
  var l = t.theme.components.searchInputLocation;
  return G(l.IconWrapper);
});
function Yo(t) {
  var l, A = t.textSize, H = A === void 0 ? "medium" : A, C = t.longitude, X = C === void 0 ? Dt : C, P = t.latitude, J = P === void 0 ? Nt : P, Q = t.apiKey, O = t.value, i = O === void 0 ? {
    inputValue: "",
    selectedValue: ""
  } : O, T = t.limit, L = T === void 0 ? 5 : T, u = t.disabled, d = t.required, W = t.placeholder, Y = W === void 0 ? "Enter your address..." : W, c = t.onChange, Z = t.onBlur, tt = t.labelProp, et = t.infoProp, ot = t.trailingText, it = t.helperTextProp, R = t.inputState, h = R === void 0 ? y.NONE : R, w = t.startAdornmentProp, rt = w === void 0 ? {
    hideAdornment: !1
  } : w, V = t.countryCode, D = t.languageCode, nt = D === void 0 ? "en" : D, N = t.accessibilityOptions, v = N === void 0 ? {} : N, $ = t.exceedOverflow, pt = $ === void 0 ? !1 : $, j = t.menuDirection, at = j === void 0 ? "down_auto" : j, E = t.menuWidth, lt = E === void 0 ? "280px" : E, mt = t.noResultText, _ = yt(t, $t), ut = Tt({
    label: "SearchInputLocation"
  }), st = Ct("SearchInputLocation"), ct = st.t, m = Pt.useRef(null), B = M(!1), g = B[0], s = B[1], f = Ot(Rt(jt)), q = M([]), a = q[0], U = q[1], dt = {
    inputValue: "",
    selectedValue: ""
  }, ht = At(), vt = v.clearButton, gt = v.searchIcon, ft = v.searchInput, It = x("combobox", Object.assign({}, ft, {
    ariaDisabled: u,
    ariaRequired: d,
    ariaInvalid: h === y.CAUTION || h === y.ERROR,
    ariaHaspopup: "listbox",
    ariaControls: "content-" + f.current,
    ariaExpanded: g
  })), bt = x("button", Object.assign({
    ariaLabel: "clear"
  }, vt)), xt = x("search", Object.assign({
    ariaLabel: "search"
  }, gt)), St = function(e) {
    var o = e.target.value;
    if (c({
      inputValue: o,
      selectedValue: i == null ? void 0 : i.selectedValue
    }, e), o.length > 1) {
      var r = "" + Vt + J + "," + X + "&limit=" + L + "&lang=" + nt + "&q=" + o + "&apiKey=" + Q;
      V && (r = r + "&in=countryCode:" + V), fetch(r).then(function(I) {
        return I.json();
      }).then(function(I) {
        return U(I.items);
      });
    } else
      U([]);
    o.length > 0 ? s(!0) : s(!1);
  }, K = function(e) {
    m && m.current && (m.current.click(), m.current.focus()), e.stopPropagation(), c(dt, e), s(!1);
  };
  return /* @__PURE__ */ p(Et, Object.assign({
    className: b(["InputAndSuggestionWrapper"])
  }, ut, {
    children: /* @__PURE__ */ Wt(S, {
      className: "no-filter",
      menuOpen: !u && g,
      exceedOverflow: pt,
      onChange: function(e, o) {
        var r;
        c == null || c({
          inputValue: o.label,
          selectedValue: o.label
        }, e), (r = m.current) == null || r.focus();
      },
      handleMenuOpen: function(e) {
        if (e) {
          var o;
          (i == null || (o = i.inputValue) == null ? void 0 : o.length) > 0 && (a == null ? void 0 : a.length) > 0 && s(e);
        } else
          s(e);
      },
      isDisabled: u,
      uniqueIdentifier: f.current,
      maxItems: Number(L),
      closeOnSelect: !0,
      menuWidth: lt,
      menuDirection: at,
      noResultText: ct("No location found", "noResultText", mt),
      disableAutoFocus: !0,
      children: [/* @__PURE__ */ p(S.Control, {
        children: /* @__PURE__ */ p(Lt, Object.assign({
          labelProp: Object.assign({
            label: wt,
            showRequiredIndicator: d
          }, tt),
          infoProp: Object.assign({
            infoText: "",
            infoType: "tooltip",
            popupTipHeader: "Info"
          }, et),
          startAdornmentProp: {
            startAdornment: rt.hideAdornment ? "" : /* @__PURE__ */ p(k, Object.assign({
              className: b(["IconWrapper"])
            }, xt, {
              tabIndex: -1,
              children: /* @__PURE__ */ p(F, {
                icon: "search"
              })
            }))
          },
          endAdornmentProp: {
            endAdornment: i.inputValue && !u ? /* @__PURE__ */ p(k, Object.assign({
              onClick: K,
              className: b(["IconWrapper", "IconWrapper--CloseButtonWrapper"]),
              onKeyDown: function(e) {
                (e.code === "Enter" || e.code === "Space") && (e.preventDefault(), K(e));
              }
            }, bt, {
              children: /* @__PURE__ */ p(F, {
                icon: "cancelCloseFilled",
                style: ht.components.searchInputLocation.IconStyle
              })
            })) : void 0
          },
          value: i.inputValue,
          type: "text",
          textSize: H,
          required: d,
          inputRef: m,
          onChange: St,
          disabled: u,
          placeholder: Y,
          onBlur: Z,
          inputState: h,
          helperTextProp: g ? void 0 : it,
          onKeyUp: function(e) {
            e.code === "Space" && e.stopPropagation();
          },
          trailingText: ot
        }, _, {
          role: "combobox",
          id: "control-" + (_.id || f.current)
        }, It))
      }), (i == null || (l = i.inputValue) == null ? void 0 : l.length) > 0 && a && (a == null ? void 0 : a.length) > 0 && (a == null ? void 0 : a.map(function(n, e) {
        var o = n.title, r = n.id;
        return /* @__PURE__ */ p(S.Item, {
          id: r || "" + e,
          label: o,
          value: o,
          isSelected: i.selectedValue === o
        }, r || e);
      }))]
    })
  }));
}
export {
  Yo as SearchInputLocation
};
